import { ReactElement } from 'react';
import parse from 'html-react-parser';
import cn from 'classnames';

import styles from './Label.module.scss';

import { Tooltip } from '../Tooltip/Tooltip';
import { useKeyboardClick } from '../../hooks/useKeyboardClick';
import { Icon } from '../Icon/Icon';
import { getDataTest } from '../../utils/dataTests';

interface LabelProps {
    children: string;
    htmlFor?: string;
    description?: string;
    className?: string;
    help?: string;
    onClick?: () => void;
    onHelpClick?: () => void;
}

export const Label = ({
    children,
    htmlFor,
    description,
    className,
    onClick,
    help,
    onHelpClick,
    ...props
}: LabelProps): ReactElement | null => {
    const handleHelpKey = useKeyboardClick(() => {
        if (onHelpClick) {
            onHelpClick();
        }
    });

    return (
        <label
            className={cn(styles.wrapper, className)}
            onClick={onClick}
            htmlFor={htmlFor}
            data-test={getDataTest(props)}
        >
            {parse(children)}

            {help && <Tooltip className={styles.tooltip} text={help} data-test={getDataTest(props, 'Tooltip')} />}

            {onHelpClick && (
                <span
                    tabIndex={0}
                    className={cn(styles.icon)}
                    onClick={onHelpClick}
                    onKeyDown={handleHelpKey}
                    data-test={getDataTest(props, 'HelpIcon')}
                    aria-label="Nápověda"
                >
                    <Icon name="info" />
                </span>
            )}

            {description && (
                <p className={styles.description} data-test={getDataTest(props, 'Description')}>
                    {description}
                </p>
            )}
        </label>
    );
};
